const COUNTRY_VARIANTS: Partial<Record<string, Record<string, string>>> = {
  de: {
    DE: 'de-DE', AT: 'de-AT', CH: 'de-CH',
    LI: 'de-LI', LU: 'de-LU', BE: 'de-BE',
  },
  fr: {
    FR: 'fr-FR', CH: 'fr-CH', BE: 'fr-BE',
    LU: 'fr-LU', MC: 'fr-MC',
  },
  it: {
    IT: 'it-IT', CH: 'it-CH',
    SM: 'it-SM', VA: 'it-VA',
  },
  nl: {
    NL: 'nl-NL', BE: 'nl-BE',
  },
  en: {
    GB: 'en-GB', IE: 'en-IE', MT: 'en-MT',
    GG: 'en-GG', JE: 'en-JE', IM: 'en-IM', GI: 'en-GI',
  },
}

const CANONICAL: Record<string, string> = {
  de: 'de-DE',
  fr: 'fr-FR',
  it: 'it-IT',
  nl: 'nl-NL',
  en: 'en-GB',
  da: 'da-DK',
  hu: 'hu-HU',
  es: 'es-ES',
}

export function resolveLocale(language: string, country: string | null): string {
  const canonical = CANONICAL[language]
  if (!canonical) return language
  if (!country) return canonical
  return COUNTRY_VARIANTS[language]?.[country.toUpperCase()] ?? canonical
}
